import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { GoogleSignInRequest, GoogleSignInResponse } from '../types/googleSignIn'

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        credentials: 'include'
    }),
    endpoints: builder => ({
        googleSignIn: builder.mutation<GoogleSignInResponse, GoogleSignInRequest>({
            query: credentials => ({
                url: '/flight/search/v2/social-media-signIn',
                method: 'POST',
                body: {
                    code: credentials.code,
                    dmType: typeof window !== 'undefined' ? window.location.hostname : '',
                    mediaType: credentials.mediaType
                },
                headers: {
                    'Content-Type': 'application/json',
                    Referer: typeof window !== 'undefined' ? window.location.hostname : ''
                }
            })
        })
    })
})

export const { useGoogleSignInMutation } = authApi
